import React from 'react';
import { SwatchPicker, Box, Copy } from '@honda-canada/design-system-react';
import PropTypes from 'prop-types';
import getDropdownOptionsData, { optionsKeys } from '../../utils/getDropdownOptionsData';
import useDropdownOptions from '../../hooks/useDropdownOptions';
import { pushGtmColorSelect } from './utils';

import themeStyles from './styles/ColorSwatches.styles';

const ContentCopy = themeStyles.apply(Copy, 'ContentCopy');
const SwatchName = themeStyles.apply(Copy, 'SwatchesContent');
const Swatch = themeStyles.apply(Box, 'Swatch');
const SwatchesRow = themeStyles.apply(Box, 'SwatchesRow');

const ColourSwatches = ({ isDark, setSelected, swatches, title }) => {
  const { dropdownOptions } = useDropdownOptions();
  const [yearData, modelData, transmissionData] = getDropdownOptionsData(dropdownOptions, [
    optionsKeys.year,
    optionsKeys.model,
    optionsKeys.transmission,
  ]);

  const modelName = modelData?.text;
  const modelYear = yearData?.value;
  const modelTransmission = transmissionData?.value;

  const selectedSwatchName = swatches.find(s => s.isSelected)?.name;

  const titleContent = (
    <ContentCopy size="small" isDark={isDark} data-testid="cy-colours-label">
      {title}
    </ContentCopy>
  );

  const swatchesContent = (
    <>
      <SwatchName size="extraSmall" data-testid="cy-colour-name">
        {selectedSwatchName}
      </SwatchName>
      <SwatchesRow as="ul">
        {swatches.map(swatch => (
          <Swatch as="li" key={swatch?.name} data-testid="cy-colour-swatch">
            <SwatchPicker
              data-testid="cy-swatch-picker-container"
              swatch={swatch}
              isDark={isDark}
              onClick={() => {
                setSelected(swatch?.key);
                pushGtmColorSelect(swatch?.key, `${modelYear}: ${modelTransmission}: ${modelName}`);
              }}
              icon={!swatch.isValid ? 'warning' : swatch.isSelected && 'checkmark'}
            />
          </Swatch>
        ))}
      </SwatchesRow>
    </>
  );
  return (
    <>
      {titleContent}
      {swatchesContent}
    </>
  );
};

ColourSwatches.propTypes = {
  isDark: PropTypes.bool,
  setSelected: PropTypes.func,
  swatches: PropTypes.arrayOf(PropTypes.shape({})),
  title: PropTypes.string,
};

ColourSwatches.defaultProps = {
  swatches: [],
};

export default ColourSwatches;
